import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.SearchFilters;

// initial state
// object name must match specification name
const filters = {
	Query: new FormControl.FilterGroup(
		'Query', '', CONST.globalProject.Query, false, true, 'textbox',
		new FormControl.Textbox('Search Term', 'Query', true), 'filter-search'
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };